export enum UserFields {
  USERNAME = "username",
  EMAIL = "email",
  PHONE = "phone",
  FIRST_NAME = "first_name",
  LAST_NAME = "last_name",
}

export enum EmailVerificationFields {
  VERIFICATION_CODE = "verification_code",
}

export enum EmailPreferencesFields {
  RENTAL_REMINDERS = "rental_reminders",
  ALLOW_MARKETING_CAMPAIGNS = "allow_marketing_campaigns",
}
